import BaseRepository from '@repositories/desktop/BaseRepository';
import AjaxService from '@services/AjaxService';

export default class InfoRepository extends BaseRepository {
  protected baseUrl = '';

  public constructor(protected readonly ajaxService: AjaxService) {
    super(ajaxService)
  }

  public loadManuals(): Promise<any> {
    return this.ajaxService.getJson('/api/desktop/manuals');
  }
}
